import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Injectable()
export class EpioneDateFormatter extends NgbDateParserFormatter {

	private FORMAT: string = 'YYYY-MM-DD';

	setFormat(format: string) {
    	this.FORMAT = format;
  	}

	parse(value: string | Date): NgbDateStruct | null {
		if (value && value !== '') {
			let date = moment(value);
			return {
				day: date.date(),
				month: date.month() + 1, // moment 0 indexes, this plugin 1 indexes
				year: date.year()
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		if (date) {
			const lv = moment({
				year: date.year,
				month: date.month - 1,
				day: date.day,
			});
			return lv.format(this.FORMAT);
		}
		return '';
	}
}
